"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
const CardType_1 = require("@/common/cards/CardType");
const utils_1 = require("@/common/utils/utils");
const ALL_CARDS = [
    ...(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.AUTOMATED)),
    ...(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.ACTIVE)),
    ...(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.EVENT)),
    ...(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.CEO)),
].map(utils_1.toName)
    .sort((a, b) => a.localeCompare(b));
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardsFilter',
    props: {
        title: {
            type: String,
            required: true,
        },
        hint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            selected: [],
            searchMatches: [],
            searchTerm: '',
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    computed: {
        typedRefs() {
            return this.$refs;
        },
    },
    methods: {
        isPrelude(cardName) {
            return (0, ClientCardManifest_1.getCard)(cardName)?.type === CardType_1.CardType.PRELUDE;
        },
        isCEO(cardName) {
            return (0, ClientCardManifest_1.getCard)(cardName)?.type === CardType_1.CardType.CEO;
        },
        expansions(cardName) {
            return (0, ClientCardManifest_1.getCard)(cardName)?.compatibility ?? [];
        },
        removeCard(cardName) {
            (0, utils_1.inplaceRemove)(this.selected, cardName);
        },
        addCard(cardName) {
            if (this.selected.includes(cardName))
                return;
            this.selected.push(cardName);
            this.selected.sort();
            this.searchTerm = '';
            this.typedRefs.filter.focus();
        },
    },
    watch: {
        selected: {
            handler(value) {
                this.$emit('cards-list-changed', value);
            },
            deep: true,
        },
        searchTerm(value) {
            this.searchMatches = [];
            if (value.indexOf(',') !== -1) {
                const cardNames = new Set(value.split(',').map((c) => c.trim()));
                for (const item of ALL_CARDS) {
                    if (cardNames.has(item)) {
                        this.addCard(item);
                    }
                }
                return;
            }
            if (value === '') {
                return;
            }
            const searchTermLowercase = value.toLowerCase();
            for (const candidate of ALL_CARDS) {
                if (candidate.toLowerCase().indexOf(searchTermLowercase) >= 0) {
                    this.searchMatches.push(candidate);
                }
                if (this.searchMatches.length === 5) {
                    return;
                }
            }
        },
    },
    mounted() {
        this.typedRefs.filter.focus();
    },
});
